import { FC } from 'react';

import { PsychicCardAppearance } from 'constants/enums';
import { ProfileViewInterface } from 'components/Sections/PsychicsSetMediumSizeImagesClone/declarations';
import CardsViewButton from 'src/shared/ui/CardsViewButton/CardsViewButton';

import styles from '../PsychicFilter.module.scss';

const ProfileView: FC<ProfileViewInterface> = ({
  gridViewLink,
  listViewLink,
  displayGridView,
  displayListView,
  psychicCardAppearance,
}) => {
  const isListView = psychicCardAppearance === PsychicCardAppearance.LIST;
  const isTileView = psychicCardAppearance === PsychicCardAppearance.TILE;

  const clickWrapper = (condition: boolean, func?: () => void) => {
    if (condition || !func) {
      return;
    }

    func();
  };

  return (
    <div className={styles.profileView}>
      <CardsViewButton
        shape="rectangle"
        link={gridViewLink}
        isSelected={isTileView}
        onClick={() => clickWrapper(isTileView, displayGridView)}
        disabled={isTileView}
      />
      <CardsViewButton
        shape="square"
        link={listViewLink}
        isSelected={isListView}
        onClick={() => clickWrapper(isListView, displayListView)}
        disabled={isListView}
      />
    </div>
  );
};

export default ProfileView;
